import { render, staticRenderFns } from "./crudOrdersCourses.vue?vue&type=template&id=661364d2&scoped=true&"
import script from "./crudOrdersCourses.vue?vue&type=script&lang=js&"
export * from "./crudOrdersCourses.vue?vue&type=script&lang=js&"
import style0 from "./crudOrdersCourses.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudOrdersCourses.vue?vue&type=style&index=1&id=661364d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661364d2",
  null
  
)

export default component.exports